import { downloadUrlA } from '@iconik-io/core/src/download_url_a';
import {
  httpGetAssetsByAssetIdSegmentsCsv,
  httpGetAssetsByAssetIdSegmentsSrt,
  httpGetAssetsByAssetIdSegmentsText,
  httpGetAssetsByAssetIdSegmentsVtt,
} from '@iconik-io/iconik-api/src/services/assets';

import { getEntityById } from '../entities/utils';
import {
  COMMENT_DOWNLOADS_WORDS_PER_LINE,
  WORD_COUNT_DEFAULT,
} from '../files/thunks';
import { createAppThunk } from '../types';

export const downloadCommentsText = createAppThunk(
  (assetId: string, versionId: string | undefined) =>
    (dispatch, getState): void => {
      const state = getState();
      const asset = getEntityById(state, 'assets', assetId);
      if (!asset) {
        return;
      }

      dispatch(
        httpGetAssetsByAssetIdSegmentsText(assetId, {
          segment_type: 'COMMENT',
          version_id: versionId,
        }),
      ).then(({ body }) => {
        const downloadUrl = `data:text/plain;charset=utf-8,${encodeURIComponent(
          String(body),
        )}`;
        downloadUrlA(downloadUrl, `${asset.title}-comment.txt`);
      });
    },
);

export const downloadCommentsCsv = createAppThunk(
  (assetId: string, versionId: string | undefined) =>
    (dispatch, getState): void => {
      const state = getState();
      const asset = getEntityById(state, 'assets', assetId);
      if (!asset) {
        return;
      }

      dispatch(
        httpGetAssetsByAssetIdSegmentsCsv(assetId, {
          segment_type: 'COMMENT',
          version_id: versionId,
        }),
      ).then(({ body }) => {
        const downloadUrl = `data:text/plain;charset=utf-8,${encodeURIComponent(
          String(body),
        )}`;
        downloadUrlA(downloadUrl, `${asset.title}-comment.csv`);
      });
    },
);

export const downloadCommentsVtt = createAppThunk(
  (assetId: string, versionId: string | undefined) =>
    (dispatch, getState): void => {
      const state = getState();
      const asset = getEntityById(state, 'assets', assetId);
      if (!asset) {
        return;
      }

      dispatch(
        httpGetAssetsByAssetIdSegmentsVtt(assetId, {
          segment_type: 'COMMENT',
          version_id: versionId,
          words_per_line: Number(
            localStorage.getItem(COMMENT_DOWNLOADS_WORDS_PER_LINE) ??
              WORD_COUNT_DEFAULT,
          ),
        }),
      ).then(({ body }) => {
        const downloadUrl = `data:text/plain;charset=utf-8,${encodeURIComponent(
          String(body),
        )}`;
        downloadUrlA(downloadUrl, `${asset.title}-comment.vtt`);
      });
    },
);

export const downloadCommentsSrt = createAppThunk(
  (assetId: string, versionId: string | undefined) =>
    (dispatch, getState): void => {
      const state = getState();
      const asset = getEntityById(state, 'assets', assetId);
      if (!asset) {
        return;
      }

      dispatch(
        httpGetAssetsByAssetIdSegmentsSrt(assetId, {
          segment_type: 'COMMENT',
          version_id: versionId,
          words_per_line: Number(
            localStorage.getItem(COMMENT_DOWNLOADS_WORDS_PER_LINE) ??
              WORD_COUNT_DEFAULT,
          ),
        }),
      ).then(({ body }) => {
        const downloadUrl = `data:text/plain;charset=utf-8,${encodeURIComponent(
          String(body),
        )}`;
        downloadUrlA(downloadUrl, `${asset.title}-comment.srt`);
      });
    },
);
